import * as React from 'react';

const Email = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={22} height={22} {...props}>
        <g fill="none" fillRule="evenodd">
            <path d="M-1337-1095H583v4595h-1920z" />
            <g
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.25}
                transform="translate(1 1)"
            >
                <path d="M0 14.348A5.872 5.872 0 0 1 8.174 8.95" />
                <circle cx={5.87} cy={3.587} r={3.587} />
                <path d="M19.565 13.044v5.217c0 .72-.584 1.304-1.304 1.304h-7.826c-.72 0-1.305-.584-1.305-1.304v-5.217" />
                <path d="M19.565 13.044c0-.72-.584-1.305-1.304-1.305h-7.826c-.72 0-1.305.584-1.305 1.304l4.526 2.828c.423.264.96.264 1.383 0z" />
            </g>
        </g>
    </svg>
);
export default Email;
